exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".invoiceExpansion .v-expansion-panel__header{background-color:#15155d}.invoiceExpansion .v-icon{color:#fff}", "", {"version":3,"sources":["D:/Acuify_Child_Products/Temp/src/components/Buyers/Invoice/InvoiceScreen.vue"],"names":[],"mappings":"AACA,6CACE,wBAA0B,CAC3B,AACD,0BACE,UAAa,CACd","file":"InvoiceScreen.vue","sourcesContent":["\n.invoiceExpansion .v-expansion-panel__header {\r\n  background-color: #15155d;\n}\n.invoiceExpansion .v-icon {\r\n  color: white;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1a121959","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Buyers/Invoice/InvoiceScreen.vue
// module id = 1754
// module chunks = 0